import { ISapElement } from '@/models/api/models/sapElement';
import { GetterTree, MutationTree, Module, ActionTree } from 'vuex';
import { RootState } from '../rootState';
import store from '..';
import Element from '@/models/element';
import { priceManager } from '@/models/priceManager';
import { ISimpleSapElement } from '@/models/api/models/simpleSapElement';
import { apiClient } from '@/plugins/api';
import { Calculation } from '@/models/api/models/calculation';
import { Price } from '@/models/api/models/price';
import { Delivery } from '@/models/api/models/delivery';
import { ElementsToSapElementsConverter } from '@/models/sap/elementsToSapElementsConverter';

export interface SapModule {
    quantity: number;
    elements: ISapElement[];
    calculation: { value: Calculation, loading: boolean };
}

const elementsToSapElementsConverter = new ElementsToSapElementsConverter();

const actions: ActionTree<SapModule, RootState> = {
    sapCalculate(context) {
        store.commit('configurationChange');
        context.state.calculation.loading = true;
        const elements: Element[] = [];
        elements.push(...store.getters.scene.elements);
        elements.push(...store.getters.scene.backs);
        const elements_erp = elementsToSapElementsConverter.convertAlone(elements);
        (apiClient.getPrice(elements_erp)
            .then((value) => {
                context.state.calculation.value = value;
            }, (error) => { }) as any)
            .finally((x) => {
                context.state.calculation.loading = false;
            });
    },
};

const getters: GetterTree<SapModule, RootState> = {
    sap(state): SapModule {
        return state;
    },
    price(state): number {
        const elements: Element[] = store.getters.scene.elements;
        return priceManager.getPrice(state.elements, elements);
    },
};

const mutations: MutationTree<SapModule> = {
    setSapElements(state, elements: ISapElement[]) {
        state.elements = elements;
    },
    setQuantity(state, quantity: number) {
        if (quantity > 99) {
            quantity = 99;
        }
        state.quantity = quantity;
    },
};

const currentState: SapModule = {
    quantity: 1,
    elements: [],
    calculation: {
        value: {
            price: new Price('', '', 0, 0),
            delivery: new Delivery(0, 0, 0, ''),
        },
        loading: false,
    },
};

export const SapModule: Module<SapModule, RootState> = {
    state: currentState,
    actions,
    getters,
    mutations,
};
